//frontend/src/slices/apiSlice.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constans';
import { logout } from './authSlice';

const rawBaseQuery = fetchBaseQuery({ baseUrl: BASE_URL });

/**
 * ОБЁРТКА НАД БАЗОВЫМ ЗАПРОСОМ: единая реакция на 401.
 *
 * МЕТОДИЧКА: какую проблему это решает.
 *
 * userInfo хранится в localStorage, а сессия — в куке. Это два независимых
 * хранилища с разным сроком жизни. Когда кука протухает, localStorage
 * об этом не узнаёт: приложение продолжает считать пользователя вошедшим,
 * рисует меню и экраны, но каждый запрос возвращает 401.
 *
 * Человек видит вечные спиннеры и пустые списки. Ошибки нет — есть
 * отсутствие данных, что гораздо хуже: непонятно, это сбой сети,
 * тормоза или у него правда нет объектов. Единственный выход —
 * догадаться нажать «Выйти».
 *
 * Теперь 401 в любом запросе означает одно и то же действие: чистим
 * состояние и отправляем на форму входа. Ответ на вопрос «что делать
 * при 401» задан ОДИН РАЗ, а не повторяется в каждом компоненте —
 * и не может быть забыт в новом.
 *
 * ПАТТЕРН: перехват на границе. Все запросы уже проходят через одну
 * точку, значит и обработка общих для них ситуаций должна жить здесь.
 */
const baseQuery = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  /**
   * Запрос логина исключаем намеренно.
   *
   * Неверный пароль — это тоже 401, но реагировать на него выходом
   * из системы бессмысленно: пользователь и так не внутри. Хуже того,
   * получилась бы петля: попытка входа → 401 → редирект на /auth →
   * пользователь снова вводит пароль.
   */
  const url = typeof args === 'string' ? args : args?.url ?? '';
  const isAuthRequest = url.includes('/login') || url.includes('/logout');

  if (result?.error?.status === 401 && !isAuthRequest) {
    api.dispatch(logout());

    /**
     * Кеш RTK Query чистим обязательно. Иначе данные предыдущего
     * пользователя останутся в памяти и покажутся следующему,
     * кто войдёт на этом же устройстве, — пока не истечёт время жизни
     * кеша. На общем планшете в цехе это утечка данных, а не косметика.
     */
    api.dispatch(apiSlice.util.resetApiState());

    /**
     * window.location, а не navigate: этот код выполняется вне дерева
     * React, доступа к роутеру здесь нет.
     *
     * Полная перезагрузка страницы тут скорее плюс: она гарантированно
     * сбрасывает всё состояние в памяти, и следующий пользователь
     * начинает с чистого листа.
     */
    if (!window.location.pathname.startsWith('/auth')) {
      window.location.href = '/auth';
    }
  }

  return result;
};
// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { BASE_URL } from '../constans';

// const baseQuery = fetchBaseQuery({ baseUrl: BASE_URL });

// // const apiSlice = createApi({
// //   baseQuery,
// //   tagTypes: ['Project', 'User', 'Type', 'Stage', 'Products', 'Product'],
// //   endpoints: (builder) => ({}),
// // });

const apiSlice = createApi({
  baseQuery,
  tagTypes: ['Project', 'User', 'Type', 'Types', 'Stage',
    'Products', 'Product', 'ProductGroup', 'News',
    'StagesOfType', 'LeadSource', 'LeadSources', 'Reports', 'Report', 'Regions', 'Region',
    'BuildingProject', 'BuildingProjects'
  ], // Добавляем новый tag
  endpoints: (builder) => ({}),
});

export { apiSlice };
